import { render, staticRenderFns } from "./explain.vue?vue&type=template&id=70ebf6d8&scoped=true"
import script from "./explain.vue?vue&type=script&lang=js"
export * from "./explain.vue?vue&type=script&lang=js"
import style0 from "./explain.vue?vue&type=style&index=0&id=70ebf6d8&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70ebf6d8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('70ebf6d8')) {
      api.createRecord('70ebf6d8', component.options)
    } else {
      api.reload('70ebf6d8', component.options)
    }
    module.hot.accept("./explain.vue?vue&type=template&id=70ebf6d8&scoped=true", function () {
      api.rerender('70ebf6d8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/user/duty/explain.vue"
export default component.exports